import { useTranslation } from "react-i18next";
import UserIcon from "../../atoms/images/UserIcon";
import Text from "./Text";
import { Link } from "react-router-dom";

const UserGreeting = ({ attrInfo }) => {
  const { t } = useTranslation();

  const givenName =
    attrInfo.find((attr) => attr.Name === "given_name")?.Value || "";

  return (
    <div className="flex flex-col gap-1">
      <UserIcon />
      <Text variant="h3">{t("home.welcome", { name: givenName })}</Text>
      <Link to="/account-info">
        <Text variant="underline" className="text-vestelColor">
          {t("home.accountInfo")}
        </Text>
      </Link>
      <Text variant="semibold">{t("home.selectWebsite")}</Text>
    </div>
  );
};

export default UserGreeting;
